export enum AuthResponseEnum {
    Authenticated = 0,
    WrongCredentials = 1,
    ServerUnreachable = 2,
    AccountBlocked = 3,
    MFARequired = 4,
    NotAuthenticated = 5,
    AssignedMoreThanAvailableOrganizationLicenses = 6,
    ExpiredOrganizationLicenses = 7,
    NoClinkProfileFoundForThisWSFedProfile = 9,
}
